import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=60eab4a1&scoped=true"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"
import style0 from "./Exam.vue?vue&type=style&index=0&id=60eab4a1&prod&lang=scss&scoped=true"
import style1 from "./Exam.vue?vue&type=style&index=1&id=60eab4a1&prod&lang=scss"
import style2 from "./Exam.vue?vue&type=style&index=2&id=60eab4a1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eab4a1",
  null
  
)

export default component.exports